import { atom } from 'recoil';

export const phoneNumberRecoil = atom<string>({
  key: 'phoneNumberRecoil',
  default: '',
});

/**
 * idle : 대기중
 * dialing : 통화 연결중
 * connected : 통화중
 * ended : 통화 종료
 * ringing : 수신 연결중
 * */
export type TCallStatus = 'idle' | 'dialing' | 'connected' | 'ended' | 'ringing';
export const callStatusRecoil = atom<TCallStatus>({
  key: 'callStatusRecoil',
  default: 'idle',
});

// 전역적으로 통화 컴포넌트 띄우는 recoil
export const callIsVisibleRecoil = atom<boolean>({
  key: 'callIsVisibleRecoil',
  default: false,
});

// ARS, 음성통화 상태값 확인하는 recoil
// "status":"CALL" // CALL or ARS
export const inboundToggleRecoil = atom<'ARS' | 'CALL' | null>({
  key: 'inboundToggleRecoil',
  default: 'ARS',
});

// 수신자에 대한 정보를 저장하는 recoil
export const incomingCallInfoRecoil = atom<{ caller: string } | null>({
  key: 'incomingCallInfoRecoil',
  default: null,
});
